export default __webpack_public_path__ + "ui/assets/img/cancel-black-24.svg";